import { createModelsCarouselFaConfig } from "./create-models-carousel-fa-config";

export const defaultAppConfig: Record<string, any> = {
  appContent: null,
  appsCommonsJS: '/assets/models-carousel/models-carousel-commonjs.js',
  appsUMD: '/assets/models-carousel/models-carousel-umd.js',
  createFunctionInstance: createModelsCarouselFaConfig,
};
